export default "__VITE_ASSET__bCS4KUHn__"